<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">support_agent</span>
      <h2>Support &amp; Assistance</h2>
    </div>

    <p class="section-intro">
      Si vous rencontrez un problème ou avez besoin d'aide, plusieurs canaux de support sont disponibles.
    </p>

    <!-- ===== CANAUX ===== -->
    <h3 class="sub-title">Canaux de support</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Canal</th><th>Détails</th><th>Délai de réponse</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Administrateur interne</strong></td><td>Votre administrateur ComptaMiton peut résoudre la plupart des problèmes : réinitialisation de mot de passe, attribution de rôles, corrections de données.</td><td>Immédiat</td></tr>
          <tr><td><strong>Email support</strong></td><td>Envoyez un email détaillé décrivant le problème à l'équipe technique.</td><td>24-48h</td></tr>
          <tr><td><strong>Téléphone</strong></td><td>Pour les urgences bloquantes (système inaccessible, données corrompues).</td><td>Immédiat</td></tr>
        </tbody>
      </table>
    </div>

    <!-- ===== SIGNALER UN BUG ===== -->
    <h3 class="sub-title">Signaler un problème</h3>
    <p class="section-text">
      Pour un traitement rapide, fournissez les informations suivantes :
    </p>
    <ul class="doc-list">
      <li><strong>Module concerné :</strong> Dans quel module le problème se produit (ex : Caisse, Commandes).</li>
      <li><strong>Action effectuée :</strong> Ce que vous faisiez quand le problème est apparu.</li>
      <li><strong>Message d'erreur :</strong> Le texte exact du message affiché (si applicable).</li>
      <li><strong>Capture d'écran :</strong> Une image montrant le problème.</li>
      <li><strong>Vos identifiants :</strong> Votre nom d'utilisateur et votre rôle.</li>
      <li><strong>Navigateur :</strong> Le navigateur utilisé (Chrome, Firefox, Edge…).</li>
    </ul>

    <!-- ===== PROBLÈMES COURANTS ===== -->
    <h3 class="sub-title">Problèmes courants et solutions</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Problème</th><th>Solution</th></tr>
        </thead>
        <tbody>
          <tr><td>La page ne se charge pas</td><td>Vérifiez votre connexion réseau. Essayez de rafraîchir la page (F5 ou Ctrl+R). Videz le cache du navigateur.</td></tr>
          <tr><td>Session expirée</td><td>Reconnectez-vous. La session expire après une période d'inactivité pour des raisons de sécurité.</td></tr>
          <tr><td>Données ne s'affichent pas dans le tableau</td><td>Vérifiez les filtres appliqués. Essayez de retirer les filtres et de recharger. Si le problème persiste, contactez le support.</td></tr>
          <tr><td>Erreur lors de la soumission d'un formulaire</td><td>Vérifiez que tous les champs obligatoires sont remplis. Vérifiez le format des données (nombres, dates). Si l'erreur persiste, notez le message exact et contactez le support.</td></tr>
          <tr><td>PDF/Excel ne se télécharge pas</td><td>Vérifiez que votre navigateur autorise les téléchargements. Désactivez temporairement le bloqueur de pop-ups.</td></tr>
        </tbody>
      </table>
    </div>

    <div class="info-card info">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#5b9bd5">info</span>
        Version de l'application
      </div>
      <p>
        ComptaMiton — Application de gestion commerciale et comptable.<br />
        Pour connaître la version exacte, consultez le pied de page de l'application.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocSupport" };
</script>
